import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const OtherCollectionsLink = (_context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.other_collections',
    link: '/further/ressources-partenaires-ilove',
    icon: 'navigation-link__other-collections',
});